module.exports = __webpack_public_path__ + "static/img/partnersk.4182a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partnersk.png
// module id = USsp
// module chunks = 1